import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[viaUiInputRestrictions]',
})
export class InputRestrictionsDirective {
  regexStr = `^[a-zA-Z0-9' ]*$`;
  
  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event:any) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event:any) {
      this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Za-z ]/g, '').replace(/\s/g, '');
      event.preventDefault();
  }
}
